module.exports = __webpack_public_path__ + "img/flying_pudding.177a0007.jpg";